import { useTheme } from '@shopify/restyle';
import { Row } from 'app/design/primitives/box';
import { Thumbnail } from 'app/design/primitives/thumbnail';
import type { Theme } from 'app/shopify';
import { IconUserCircle } from '@tabler/icons-react-native';
import { ICON_STROKE_WIDTH } from 'app/utils/constants';
import type { InvitedUsers } from './shared';

export function ReferralProgram202506Users({
  invitedUsers,
  numInvited,
}: {
  invitedUsers: InvitedUsers;
  numInvited: number;
}) {
  const theme = useTheme<Theme>();
  return (
    <Row
      alignItems="center"
      alignSelf="center"
      flexWrap="wrap"
      gap="spacing.general.x4"
      style={{ justifyContent: 'center', marginBottom: theme.spacing['spacing.general.x4'] }}
    >
      {invitedUsers.map((invitedUser) => (
        <Thumbnail
          height={30}
          key={invitedUser.id}
          source={{ uri: invitedUser.profile.picture }}
          style={{ marginBottom: theme.spacing['spacing.general.x2'] }}
        />
      ))}
      {numInvited < 1 ? <IconUserCircle strokeWidth={ICON_STROKE_WIDTH} /> : null}
      {numInvited < 2 ? <IconUserCircle strokeWidth={ICON_STROKE_WIDTH} /> : null}
      {numInvited < 3 ? <IconUserCircle strokeWidth={ICON_STROKE_WIDTH} /> : null}
      {numInvited < 4 ? <IconUserCircle strokeWidth={ICON_STROKE_WIDTH} /> : null}
      {numInvited < 5 ? <IconUserCircle strokeWidth={ICON_STROKE_WIDTH} /> : null}
    </Row>
  );
}
